import apiClient from './index'

export default {
  misPermisos() {
    return apiClient.get('/auth/me/permisos')
  },
  // Administración (requiere admin.permisos)
  catalogo() {
    return apiClient.get('/admin/permisos/catalogo')
  },
  grupos() {
    return apiClient.get('/admin/permisos/grupos')
  },
  crearGrupo(datos) {
    return apiClient.post('/admin/permisos/grupos', datos)
  },
  editarGrupo(codigo, datos) {
    return apiClient.put(`/admin/permisos/grupos/${codigo}`, datos)
  },
  borrarGrupo(codigo) {
    return apiClient.delete(`/admin/permisos/grupos/${codigo}`)
  },
  usuarios() {
    return apiClient.get('/admin/permisos/usuarios')
  },
  crearUsuario(datos) {
    return apiClient.post('/admin/permisos/usuarios', datos)
  },
  editarUsuario(id, datos) {
    return apiClient.put(`/admin/permisos/usuarios/${id}`, datos)
  },
  cambiarClave(id, password) {
    return apiClient.post(`/admin/permisos/usuarios/${id}/clave`, { password })
  },
  efectivos(id) {
    return apiClient.get(`/admin/permisos/usuarios/${id}/efectivos`)
  },
  auditoria(limite = 200) {
    return apiClient.get('/admin/permisos/auditoria', { params: { limite } })
  }
}
